import { FormGroup, Input, Label, Spinner } from "reactstrap";
import ColorPickerButton from "../Components/Create/Step1/ColorPickerButton";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from "../Config/secrets";
import { uploadFileToBucket } from "../Utils";

const EditPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [name, setName] = useState(state?.name || '');
  const [logo, setLogo] = useState(state?.logo || '');
  const [theme, setTheme] = useState(state?.theme || '');
  const [loading, setLoading] = useState(false);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(file);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const logo_url = typeof logo === 'string' ? logo : await uploadFileToBucket("/company-logos", logo);

      const response = await axios.put(`${API_URL}/company/edit`, { id: state?.id, name, logo: logo_url, theme });

      toast.success(response?.data?.message);
      navigate('/home');
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const logo_url = typeof logo === 'string' ? logo : window.URL.createObjectURL(logo);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-2">
      <h2>Edit Company Details</h2>

      <FormGroup className="mt-0 w-25">
        <Label>Company Name</Label>
        <Input
          placeholder="Enter company name"
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </FormGroup>

      <FormGroup className="w-25">
        <Label>Company Logo</Label>
        <Input
          type="file"
          accept="image/*"
          className="form-control"
          onChange={handleLogoChange}
        />
        {logo && <img src={logo_url} alt="Logo Preview" className="mt-2" style={{ width: '100px', height: '100px', backgroundColor: '#d1d1d1', objectFit: 'contain' }} />}
      </FormGroup>

      <FormGroup className="w-25">
        <Label>Theme Color</Label>
        <ColorPickerButton
          selectedColor={theme}
          onColorSelect={(color) => setTheme(color)}
          width="100%"
        />
      </FormGroup>
      <div className="d-flex justify-content-center gap-3 mt-4">
        <button className="btn btn-primary" onClick={handleSubmit}>
          Edit {loading && <Spinner size='sm' />}
        </button>
      </div>
    </div>
  );
};

export default EditPage;
